module.exports = __webpack_public_path__ + "img/Anhänger_FKH.c1645b49.svg";